const riot = require('riot');

riot.tag2('module-table', '<div class="s-full f fclm {getScrollClass()}"> <div class="f flex-fixed"> <div class="w32 flex-fixed border-bottom border-top border-gray_10 bg-gray_05"></div> <div class="f fm w-full pl8 pr16 py11 text-navy ts-table-th border-bottom border-top border-gray_10 bg-gray_05 {schema.class} {getAlignClass(schema.align)}" each="{schema in opts.schemas}"> <div class="w-full">{schema.label}</div> </div> <div class="w32 flex-fixed border-bottom border-top border-gray_10 bg-gray_05"></div> </div> <div class="w-full flex-height-auto"> <div class="f text-navy hover-trigger {&quot;cursor-pointer&quot; : opts.getHref &amp;&amp; opts.getHref(item) || opts.clickEvent}" each="{item in opts.items}" onclick="{onRowClick}"> <div class="w32 flex-fixed border-bottom border-gray_10 hover-bg-translucent"></div> <div class="f fm w-full pl8 pr16 py11 word-break-all ts-table-td border-bottom border-gray_10 hover-bg-translucent {schema.class} {getAlignClass(schema.align)}" each="{schema in opts.schemas}"> <div class="w-full" if="{shouldShow(item, schema) &amp;&amp; !schema.component}">{getCellText(item, schema)}</div> <div class="w-full" if="{shouldShow(item, schema) &amp;&amp; schema.component}" data-is="cell-{schema.component}" schema="{schema}" item="{item}" get-cell-text="{getCellText}"></div> </div> <div class="w32 flex-fixed border-bottom border-gray_10 hover-bg-translucent"></div> </div> </div> </div>', 'module-table,[data-is="module-table"]{display:block}', '', function(opts) {

    this.getCellText = (item, schema) => {

      if (schema.text) return schema.text;

      let value = app.utils.$get(item, schema.id);
      if (schema.getText) value = schema.getText(value, item);
      return value;
    };

    this.getAlignClass = (align = 'left') => {
      return {
        left: 'text-left',
        right: 'text-right',
        center: 'text-center',
      }[align];
    };

    this.onRowClick = (e) => {
      if (this.opts.clickEvent) {
        this.opts.clickEvent(e.item.item, e);
        return ;
      }

      const href = this.opts.getHref && this.opts.getHref(e.item.item);
      if (!href) return ;
      const target_url = new URL(href, spat.config.domain);

      if (target_url.origin === spat.config.domain) {
        spat.router.push(href);
      }
      else {
        window.open(href, '_blank');
      }
    };

    this.getScrollClass = () => {
      if (this.opts.scrollType === 'none') return '';
      return {
        x: 'overflow-x-scroll',
        y: 'overflow-y-scroll',
      }[this.opts.scrollType] || 'overflow-scroll';
    };

    this.shouldShow = (item, schema) => {

      if (!schema.shouldShow) return true;

      return schema.shouldShow(item, schema);
    };
});